import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
// routes
import { PATH_LMS } from '../routes/paths';
import { RoleType } from 'src/@types/lms/enums';

// ----------------------------------------------------------------------

type GuestGuardProps = {
  children: ReactNode;
};

export default function GuestGuard({ children }: GuestGuardProps) {
  const { isAuthenticated, user } = useAuth();

  if (isAuthenticated) {
    const roleNav = (user?.role === RoleType.Admin || user?.role === RoleType.CompanyUser || user?.role === RoleType.Coordinator) ? PATH_LMS.home : PATH_LMS.inspections.list;
    return <Navigate to={roleNav} />;
  }

  return <>{children}</>;
}
